import script from "./HeroCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroCard.vue?vue&type=script&setup=true&lang=js"

import "./HeroCard.vue?vue&type=style&index=0&id=5d609acb&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d609acb"]])

export default __exports__